import React from "react"
import { connect } from "react-redux"
import moment from "moment"

import VisualizationDisplay from 'search-new/containers/Visualization/VisualizationDisplay/index'

import MapWrapper from 'search-new/components/Visualization/VisualizationWrappers/MapWrapper'
import MapSidebar from 'search-new/components/Visualization/VisualizationSidebars/MapSidebar'

import LineWrapper from 'search-new/components/Visualization/VisualizationWrappers/LineWrapper'
import LineSidebar from 'search-new/components/Visualization/VisualizationSidebars/LineSidebar'
import { selectDataMaxDateRange, selectFilterDates } from 'search-new/selectors'

import BarPieWrapper from 'search-new/components/Visualization/VisualizationWrappers/BarPieWrapper'
import BarPieSidebar from 'search-new/components/Visualization/VisualizationSidebars/BarPieSidebar'

import WordCloudWrapper from 'search-new/components/Visualization/VisualizationWrappers/WordCloudWrapper'
import WordCloudSidebar from 'search-new/components/Visualization/VisualizationSidebars/WordCloudSidebar'

export default function genericVisualizationDisplay(props) {
    return <VisualizationDisplay {...props} />
}

export const MapDisplay = props =>
    genericVisualizationDisplay({
        ...props,
        visualizationWrapper: MapWrapper,
        sidebarComponent: MapSidebar,
        visualizationKey: 'map',
        shouldIgnoreFilters: props.shouldIgnoreFilters ?? true,
        shouldDeferFilterApplication: false,
    })

/* ********************************************************************************* */

const UnconnectedLineDisplay = props =>
    genericVisualizationDisplay({
        ...props,
        visualizationWrapper: LineWrapper,
        sidebarComponent: LineSidebar,
        visualizationKey: "trends",
        shouldIgnoreFilters: false,
        shouldLoadDataFunc: (oldProps, newProps) => {
            // if there are no oldProps, this is on mount, and on mount
            // we want to load the date filters.
            if (!oldProps) {
                return true
            }

            const oldDates = oldProps.visualizationFilterValues
            const newDates = newProps.visualizationFilterValues

            // if the date of the graph has been changed, check if it's
            // within the max data that we have. If it's within the data range,
            // return false and do not reload data. If it's outside the data range,
            // return true.

            const hasNewDates = (typeof oldDates.start !== typeof newDates.start)
                || (typeof oldDates.end !== typeof newDates.end)
                || (oldDates.start && !oldDates.start.isSame(newDates.start, 'day'))
                || (oldDates.end && !oldDates.end.isSame(newDates.end, 'day'))

            // the viz filter values are moment objects!!! (date filters deserialize to moments!)
            if (hasNewDates) {
                const newDateObjStart = newDates.start && newDates.start.toDate()
                const newDateObjEnd = newDates.end && newDates.end.toDate()

                const withinDataRange = newDateObjStart >= props.maximumDateRange.start && newDateObjEnd <= props.maximumDateRange.end

                return !withinDataRange
            }

            return true
        },
        modifyDataOnLoad: data =>
            data.map(datum => Object.assign({}, datum, { date: moment(datum.date, "YYYYMMDD").toDate() })),
        shouldDeferFilterApplication: false,
    })

// we need the maximum date range here to determine whether
// or not to load data, and therefore need to connect it in (because
// the generic VisualizationDisplay will not have this prop). The
// other alternative is to calculate the date range from the
// data each time, but that seems repetitive, wouldn't you say?
const lineMapStateToProps = (state, props) => ({
    maximumDateRange: selectDataMaxDateRange(state, props)
})

export const LineDisplay = connect(lineMapStateToProps, null)(UnconnectedLineDisplay)

/* ********************************************************************************* */

export const BarPieDisplay = props =>
    genericVisualizationDisplay({
        ...props,
        visualizationWrapper: BarPieWrapper,
        sidebarComponent: BarPieSidebar,
        visualizationKey: "frequency",
        shouldIgnoreFilters: false,
        shouldDeferFilterApplication: true,
    })

/* ********************************************************************************* */

export const WordCloudDisplay = props =>
    genericVisualizationDisplay({
        ...props,
        visualizationWrapper: WordCloudWrapper,
        sidebarComponent: WordCloudSidebar,
        visualizationKey: "word_cloud",
        shouldIgnoreFilters: false,
        shouldDeferFilterApplication: false,
    })
